export function tabs () {
    const Tabs = window.GOVUKFrontend.Tabs
    let   $tab = document.querySelector('[data-module="govuk-tabs"]')
    if ($tab) {
      new Tabs($tab).init()
    }
 }
